var map = {
	"./404.png": 65747,
	"./404.webp": 28466,
	"./about-2-bg.jpg": 39248,
	"./about-2.jpg": 48602,
	"./about.jpg": 81016,
	"./about/about-head-bg.jpg": 12925,
	"./about/about-head-bg.webp": 75400,
	"./about/about-page-section-one-bg.jpg": 53432,
	"./about/about-page-section-one-bg.webp": 72518,
	"./about/about-page-section-three-bg.png": 72956,
	"./about/about-page-section-three-bg.webp": 63352,
	"./about/about-page-section-two-bg-old.jpg": 37860,
	"./about/about-page-section-two-bg-old.webp": 89132,
	"./about/about-page-section-two-bg.jpg": 44003,
	"./about/about-page-section-two-bg.webp": 65881,
	"./about/vission-mission-2.jpg": 70776,
	"./about/vission-mission-3.jpeg": 35837,
	"./about/visson-mission-1.jpg": 24874,
	"./admin/VidhyaShree.jpg": 47234,
	"./admin/admin-07.jpg": 84054,
	"./admin/arpitha-g.jpeg": 26154,
	"./admin/arpitha-g.jpg": 46303,
	"./admin/chandrakalamohan.jpg": 43523,
	"./admin/haneef.jpg": 92918,
	"./admin/major-joyshree.jpg": 7483,
	"./admin/major.jpg": 29529,
	"./admin/mysore/akshata-1.jpeg": 23955,
	"./admin/mysore/akshata.jpg": 68124,
	"./admin/mysore/bharath-b-k.jpg": 41723,
	"./admin/mysore/francila-1.jpeg": 7841,
	"./admin/mysore/francila.jpeg": 23751,
	"./admin/mysore/gokulendu-h-l.jpg": 24673,
	"./admin/mysore/kiran-1.jpg": 43322,
	"./admin/mysore/kiran-raj.jpg": 30151,
	"./admin/mysore/maria-alphonso.jpg": 78038,
	"./admin/mysore/mary-infancia.jpg": 85155,
	"./admin/mysore/sheikh-shahul.jpg": 36418,
	"./admin/mysore/shobha-rani.jpg": 29225,
	"./admin/mysore/sumathi-hr-mysore.jpeg": 69797,
	"./admin/mysore/sumathi-mysore.jpg": 40997,
	"./admin/mysore/supriya.jpg": 22154,
	"./admin/mysore/varaprasad.jpeg": 61240,
	"./admin/mysore/vidya.jpg": 66976,
	"./admin/nandini.jpg": 11586,
	"./admin/old/major-joyshree.jpg": 68390,
	"./admin/old/nandini.jpg": 8658,
	"./admin/old/suchetha.jpeg": 93131,
	"./admin/parthasarathy.jpg": 25242,
	"./admin/ramanagara/santhosh-ramanagara.jpg": 8996,
	"./admin/ramanagara/sudha-ramanagara.jpg": 11125,
	"./admin/ramanagara/vijay-ramanagara.jpg": 21587,
	"./admin/ramya.jpg": 76282,
	"./admin/reshma-o.jpg": 71208,
	"./admin/reshma-old.jpg": 3353,
	"./admin/reshma.jpg": 70095,
	"./admin/shivkumar-ben.jpg": 40026,
	"./admin/shivu.jpg": 88476,
	"./admin/shivu1.jpg": 49166,
	"./admin/suchetha.jpg": 72726,
	"./admin/vanaja-dr.png": 71620,
	"./admin/vanaja-raman.png": 88764,
	"./admin/vishal.jpg": 50950,
	"./banner-new/career-page.jpg": 15338,
	"./banner-new/faqs.jpg": 75450,
	"./banner-new/patient-testimonial.jpg": 23243,
	"./bg-blog.jpg": 23244,
	"./bg-blog.webp": 28511,
	"./blog-new-1.jpg": 6712,
	"./blog-new-2.jpg": 90806,
	"./blog-new-3.jpg": 39941,
	"./blog/01.jpg": 93241,
	"./blog/02.jpg": 30308,
	"./blog/03.jpg": 38170,
	"./blog/04.jpg": 77493,
	"./blog/05.jpg": 59819,
	"./blog/06.jpg": 33351,
	"./blog/07.jpg": 16392,
	"./blog/08.jpg": 12404,
	"./blog/09.jpg": 34470,
	"./blog/10.jpg": 93081,
	"./blog/11.jpg": 89803,
	"./blog/12.jpg": 78593,
	"./blog/13.jpg": 1354,
	"./blog/14.jpg": 89421,
	"./blog/15.jpg": 1373,
	"./blog/How Radiologists and Fetal Medicine Experts Collaborate for Accurate Diagnosis.webp": 65813,
	"./blog/blog-100.png": 86202,
	"./blog/blog-101.png": 42142,
	"./blog/blog-102.png": 794,
	"./blog/blog-103.png": 49532,
	"./blog/blog-104.png": 67302,
	"./blog/blog-105.png": 89201,
	"./blog/blog-106.png": 37554,
	"./blog/blog-107.png": 89374,
	"./blog/blog-108.png": 5945,
	"./blog/blog-109.png": 943,
	"./blog/blog-110.png": 82065,
	"./blog/blog-111.png": 20720,
	"./blog/blog-112.png": 9500,
	"./blog/blog-113.png": 35904,
	"./blog/blog-114.jpg": 67098,
	"./blog/blog-115.jpg": 23288,
	"./blog/blog-116.jpg": 91610,
	"./blog/blog-117.jpg": 33630,
	"./blog/blog-118.png": 71033,
	"./blog/blog-119.png": 31676,
	"./blog/blog-120.png": 16667,
	"./blog/blog-121.png": 70594,
	"./blog/blog-122.png": 72443,
	"./blog/blog-123.png": 85336,
	"./blog/blog-124.png": 41151,
	"./blog/blog-125.png": 25458,
	"./blog/blog-126.png": 26104,
	"./blog/blog-127.png": 6087,
	"./blog/blog-128.png": 73904,
	"./blog/blog-129.jpeg": 77270,
	"./blog/blog-130.jpg": 70480,
	"./blog/blog-131.jpg": 14897,
	"./blog/blog-132.jpg": 36616,
	"./blog/blog-133.jpg": 9798,
	"./blog/blog-134.jpg": 78830,
	"./blog/blog-135.jpg": 87159,
	"./blog/blog-136.jpg": 19760,
	"./blog/blog-137.jpg": 6870,
	"./blog/blog-138.jpg": 86975,
	"./blog/blog-139.jpg": 63206,
	"./blog/blog-140.jpg": 33153,
	"./blog/blog-141.jpg": 75537,
	"./blog/blog-142.jpg": 46977,
	"./blog/blog-143.jpg": 58650,
	"./blog/blog-144.jpg": 56135,
	"./blog/blog-145.jpg": 24628,
	"./blog/blog-146.jpg": 63965,
	"./blog/blog-147.jpg": 52957,
	"./blog/blog-148.jpg": 13974,
	"./blog/blog-149.jpg": 43912,
	"./blog/blog-150.jpg": 48303,
	"./blog/blog-151.jpg": 28225,
	"./blog/blog-152.jpg": 61056,
	"./blog/blog-153.jpg": 42354,
	"./blog/blog-154.jpg": 5433,
	"./blog/blog-155.jpg": 73524,
	"./blog/blog-156.jpg": 53185,
	"./blog/blog-157.jpg": 50783,
	"./blog/blog-158.jpg": 15445,
	"./blog/blog-159.jpg": 64461,
	"./blog/blog-160.jpg": 94004,
	"./blog/blog-161.jpg": 18904,
	"./blog/blog-162.jpg": 82145,
	"./blog/blog-163.jpg": 22041,
	"./blog/blog-164.jpg": 19548,
	"./blog/blog-165.jpg": 26082,
	"./blog/blog-166.jpg": 35284,
	"./blog/blog-167.jpg": 33127,
	"./blog/blog-168.jpg": 17130,
	"./blog/blog-169.jpg": 4516,
	"./blog/blog-170.jpg": 39635,
	"./blog/blog-171.jpg": 65998,
	"./blog/blog-172.png": 76216,
	"./blog/blog-173.png": 77821,
	"./blog/blog-174.png": 74018,
	"./blog/blog-175.png": 37532,
	"./blog/blog-176.jpg": 88841,
	"./blog/blog-177.jpg": 53697,
	"./blog/blog-178.jpg": 77457,
	"./blog/blog-179.jpg": 61404,
	"./blog/blog-181.jpg": 95694,
	"./blog/blog-182.jpg": 3944,
	"./blog/blog-183.jpg": 41440,
	"./blog/blog-184.jpg": 59572,
	"./blog/blog-185.jpg": 34167,
	"./blog/blog-186.jpg": 63350,
	"./blog/blog-187.jpg": 60679,
	"./blog/blog-188.jpg": 32232,
	"./blog/blog-189.jpg": 76268,
	"./blog/blog-190.jpg": 8721,
	"./blog/blog-191.jpg": 83384,
	"./blog/blog-192.jpg": 69291,
	"./blog/blog-193.jpg": 7083,
	"./blog/blog-194.jpg": 65028,
	"./blog/blog-195.jpg": 19976,
	"./blog/blog-196.jpg": 87508,
	"./blog/blog-197.jpg": 34506,
	"./blog/blog-198.jpg": 92962,
	"./blog/blog-199.jpg": 75218,
	"./blog/blog-200.jpg": 3476,
	"./blog/blog-201.jpg": 7786,
	"./blog/blog-202.jpg": 74535,
	"./blog/blog-203.jpg": 40086,
	"./blog/blog-204.jpg": 71721,
	"./blog/blog-205.jpg": 93267,
	"./blog/blog-206.jpg": 1325,
	"./blog/blog-207.jpg": 6202,
	"./blog/blog-208.jpg": 89637,
	"./blog/blog-209.jpg": 63351,
	"./blog/blog-210.jpg": 81267,
	"./blog/blog-211.jpg": 7542,
	"./blog/blog-212.jpg": 98613,
	"./blog/blog-213.jpg": 86902,
	"./blog/blog-214.jpg": 63266,
	"./blog/blog-215.jpg": 93986,
	"./blog/blog-216.jpg": 70326,
	"./blog/blog-217.jpg": 97391,
	"./blog/blog-218.jpg": 34439,
	"./blog/blog-219.jpg": 46223,
	"./blog/blog-220.jpg": 74557,
	"./blog/blog-221.webp": 93969,
	"./blog/blog-222.jpg": 87294,
	"./blog/blog-223.webp": 42663,
	"./blog/blog-224.webp": 85579,
	"./blog/blog-225.webp": 25184,
	"./blog/blog-226.webp": 67985,
	"./blog/blog-227.webp": 98177,
	"./blog/blog-228.webp": 97331,
	"./blog/blog-229.webp": 77345,
	"./blog/blog-230.jpg": 87060,
	"./blog/blog-231.jpg": 48552,
	"./blog/blog-232.jpg": 9533,
	"./blog/blog-233-old.jpg": 38084,
	"./blog/blog-233.jpg": 44289,
	"./blog/blog-234-old.jpg": 51350,
	"./blog/blog-234.jpg": 42437,
	"./blog/blog-235.jpg": 42573,
	"./blog/blog-236.jpg": 14320,
	"./blog/blog-237.jpg": 32075,
	"./blog/blog-238.jpg": 50441,
	"./blog/blog-239.jpg": 30156,
	"./blog/blog-240.jpg": 30079,
	"./blog/blog-242.jpg": 56816,
	"./blog/blog-243.jpg": 82936,
	"./blog/blog-244.jpeg": 46576,
	"./blog/blog-245.jpg": 14969,
	"./blog/blog-246.jpg": 63600,
	"./blog/blog-247.jpg": 3199,
	"./blog/blog-248.jpg": 71717,
	"./blog/blog-249.jpg": 69557,
	"./blog/blog-250.jpg": 9167,
	"./blog/blog-251.jpg": 40960,
	"./blog/blog-252.jpg": 86389,
	"./blog/blog-253.jpg": 5501,
	"./blog/blog-254.jpg": 37260,
	"./blog/blog-255.jpg": 31076,
	"./blog/blog-28.jpg": 28206,
	"./blog/blog-30.jpg": 28052,
	"./blog/blog-31.jpg": 34054,
	"./blog/blog-33.jpg": 13297,
	"./blog/blog-34.jpg": 44532,
	"./blog/blog-35.jpg": 55060,
	"./blog/blog-36.jpg": 83779,
	"./blog/blog-37.jpg": 74010,
	"./blog/blog-38.jpg": 63438,
	"./blog/blog-39.jpg": 50503,
	"./blog/blog-40.jpg": 78643,
	"./blog/blog-41.jpg": 58250,
	"./blog/blog-42.jpg": 55237,
	"./blog/blog-43.jpg": 97330,
	"./blog/blog-44.jpg": 60944,
	"./blog/blog-45.jpg": 61961,
	"./blog/blog-46.jpg": 18698,
	"./blog/blog-47.jpg": 7648,
	"./blog/blog-48.jpg": 69648,
	"./blog/blog-49.jpg": 45017,
	"./blog/blog-50.jpeg": 99716,
	"./blog/blog-51.jpeg": 27766,
	"./blog/blog-52.jpeg": 26101,
	"./blog/blog-53.jpeg": 90510,
	"./blog/blog-54.jpg": 58453,
	"./blog/blog-55.jpeg": 37900,
	"./blog/blog-56.jpeg": 12688,
	"./blog/blog-57.jpeg": 63151,
	"./blog/blog-58.jpeg": 89126,
	"./blog/blog-59.jpg": 23079,
	"./blog/blog-60.jpg": 64532,
	"./blog/blog-61.jpg": 11814,
	"./blog/blog-62.jpeg": 43251,
	"./blog/blog-63.jpg": 29876,
	"./blog/blog-64.jpg": 43082,
	"./blog/blog-65.jpg": 66453,
	"./blog/blog-66.jpg": 51783,
	"./blog/blog-67.jpg": 30534,
	"./blog/blog-68.jpg": 37216,
	"./blog/blog-69.jpg": 60637,
	"./blog/blog-70.jpg": 18660,
	"./blog/blog-71.jpg": 47192,
	"./blog/blog-72.jpg": 58255,
	"./blog/blog-73.jpg": 1643,
	"./blog/blog-74.jpg": 65245,
	"./blog/blog-75.jpg": 75319,
	"./blog/blog-76.jpg": 8467,
	"./blog/blog-77.jpg": 7761,
	"./blog/blog-78.jpg": 3479,
	"./blog/blog-79.jpg": 76729,
	"./blog/blog-80.jpg": 85567,
	"./blog/blog-81.jpg": 21687,
	"./blog/blog-82.jpg": 80684,
	"./blog/blog-83.jpg": 14382,
	"./blog/blog-84.jpg": 30434,
	"./blog/blog-85.jpg": 48459,
	"./blog/blog-86.jpg": 81597,
	"./blog/blog-87.jpg": 2087,
	"./blog/blog-88.jpg": 58854,
	"./blog/blog-89.jpg": 67192,
	"./blog/blog-90.jpg": 26511,
	"./blog/blog-91.jpg": 40812,
	"./blog/blog-92.jpg": 33524,
	"./blog/blog-93.jpg": 75759,
	"./blog/blog-94.jpg": 28404,
	"./blog/blog-95.jpg": 99938,
	"./blog/blog-96.jpg": 12377,
	"./blog/blog-97.jpg": 92679,
	"./blog/blog-98.jpg": 6384,
	"./blog/blog-99.jpg": 91906,
	"./blog/blog-images/blog37-01.jpg": 17057,
	"./blog/blog-images/blog37-02.jpg": 37039,
	"./blog/blog-images/blog37-03.jpg": 55662,
	"./blog/blog1-176.jfif": 94663,
	"./blog/blog_12.jpg": 75180,
	"./blog/blog_13.jpg": 17216,
	"./blog/blog_14.jpg": 95033,
	"./blog/blog_15.jpg": 95934,
	"./blog/blog_16.jpg": 2448,
	"./blog/blog_17.jpg": 65408,
	"./blog/blog_18.jpg": 74099,
	"./blog/blog_19.jpg": 18472,
	"./blog/blog_20.jpg": 92637,
	"./blog/blog_21.jpg": 60082,
	"./blog/blog_22.jpg": 95121,
	"./blog/blog_23.jpg": 53491,
	"./blog/blog_24.jpg": 91124,
	"./blog/blog_25.jpg": 92630,
	"./blog/blog_26.jpg": 74277,
	"./blog/blog_27.jpg": 30595,
	"./blog/breastfeeding-women.jpg": 37172,
	"./blog/newborn-baby.jpg": 77092,
	"./blog/pneumonia-signs-treatment-prevention.jpg": 46685,
	"./blog/pregnancy-and-coronavirus.jpg": 3011,
	"./blog/soontobemom-01.jpg": 42065,
	"./blog1.jpg": 18974,
	"./blog1.webp": 91490,
	"./blog2.jpg": 29998,
	"./blog2.webp": 78654,
	"./blog3.jpg": 38302,
	"./blog3.webp": 89718,
	"./careers-bg-1.jpg": 16061,
	"./careers-bg-1.webp": 79044,
	"./central/arpitha-g.jpg": 52628,
	"./central/ashishprasad.jpg": 72455,
	"./central/ashoakbs.jpg": 93686,
	"./central/r-ramesh.png": 53953,
	"./central/ramesh-cfo.jpg": 8543,
	"./central/ramesh-cfo1.jpg": 89787,
	"./central/ramesh-cfo2.jpg": 78492,
	"./central/shekar-subbaiah-new.jpeg": 89435,
	"./central/shekhar-subbaiah1.jpg": 13574,
	"./central/shivkumar-ben.jpg": 83571,
	"./central/shivu1.jpg": 45277,
	"./dental-01.svg": 94886,
	"./dental-02.svg": 5229,
	"./desktop_1.jpg": 88987,
	"./desktop_2.jpg": 94585,
	"./desktop_3.jpg": 86307,
	"./desktop_4.jpg": 75337,
	"./diet-for-expecting-moms.jpg": 77790,
	"./doctor.png": 93160,
	"./doctors-bg.jpg": 61580,
	"./doctors-bg.webp": 92979,
	"./doctors-sec-img.jpg": 87801,
	"./doctors-sec-img.webp": 78958,
	"./doctors/AnandLingam.jpg": 30659,
	"./doctors/Aveen_Umashankar.jpg": 15654,
	"./doctors/Deepa_Bhat.jpg": 48809,
	"./doctors/Dr Abhilasha S.jpg.jpeg": 24060,
	"./doctors/Dr Mohit M.jpg.jpeg": 89545,
	"./doctors/Dr-rohit.jpg": 93531,
	"./doctors/Dr-yeshodha-s-mahesh.jpg": 17015,
	"./doctors/Dr.Chandan.jpg": 57667,
	"./doctors/Dr.Soumya.jpg": 97892,
	"./doctors/Dr.Srinivas_BV.jpg": 72756,
	"./doctors/Jyothirmayi.jpg": 78788,
	"./doctors/RAMESH_SINGH.jpg": 55479,
	"./doctors/RAVIHS.jpeg": 80525,
	"./doctors/SNEHA.jpeg": 5689,
	"./doctors/Satyanarayana.jpg": 32522,
	"./doctors/Suman.jpeg": 76550,
	"./doctors/SushmaKrishnamurthy.jpg": 57770,
	"./doctors/VIJAYKUMAR.jpg": 53906,
	"./doctors/aathira-ravindranath.png": 42234,
	"./doctors/aathira_ravindranath.jpg": 70775,
	"./doctors/abhilasha-1.jpeg": 39256,
	"./doctors/abhilasha-22.webp": 71096,
	"./doctors/abhilasha.jpg": 78397,
	"./doctors/ajay.jpg": 79866,
	"./doctors/amala-new.jpeg": 82306,
	"./doctors/amala.jpg": 92478,
	"./doctors/amritha-rao.jpg": 43788,
	"./doctors/amritha.jpg": 6007,
	"./doctors/anand-jayaram.jpg": 75043,
	"./doctors/anand-kumar-krishnappa.jpg": 73405,
	"./doctors/anand-lingan.jpg": 3392,
	"./doctors/anand-lingan1.jpg": 7723,
	"./doctors/anandLingan.jpeg": 15556,
	"./doctors/anil-b-jalan.png": 50666,
	"./doctors/anil-jalan.jpg": 17368,
	"./doctors/anjali-bp.jpg": 44382,
	"./doctors/anjana.jpg": 26839,
	"./doctors/anusha-new.jpg": 90192,
	"./doctors/aravind.jpg": 74379,
	"./doctors/archana-m.jpeg": 49877,
	"./doctors/archana.jpg": 14871,
	"./doctors/arif-doc-new.jpg": 91815,
	"./doctors/arif.jpg": 91594,
	"./doctors/arif_1.jpg": 61277,
	"./doctors/arpitha-dr-new.jpg": 99912,
	"./doctors/arun-raikar.jpg": 41864,
	"./doctors/ashika-new.JPG": 51769,
	"./doctors/ashika_r_prabhu.jpeg": 90866,
	"./doctors/ashmitha-shetty-new.png": 26372,
	"./doctors/ashmitha-shetty.jpg": 61557,
	"./doctors/ashmitha_shetty_new.png": 25662,
	"./doctors/ashoka-shetty-1.jpg": 6004,
	"./doctors/ashoka-shetty.jpg": 4981,
	"./doctors/ashwini-s.jpg": 74669,
	"./doctors/avantika.jpg": 99239,
	"./doctors/avinash.jpg": 94973,
	"./doctors/balaji-new.png": 64671,
	"./doctors/bharathi-k-r-doc.jpeg": 58769,
	"./doctors/bharathi-ramesh.jpg": 72690,
	"./doctors/bhavya.jpg": 64265,
	"./doctors/bindu-new.jpg": 55191,
	"./doctors/bindu.jpg": 94745,
	"./doctors/chaitra-rangaswamy.jpg": 72260,
	"./doctors/chandrika-anand.jpg": 96322,
	"./doctors/chaya-s-m.jpg": 11879,
	"./doctors/chethan.jpg": 30207,
	"./doctors/chethana.jpeg": 94638,
	"./doctors/chva_deepak_chowdari.png": 29539,
	"./doctors/de.nisar-ahamed.jpg": 31600,
	"./doctors/de.shahana.jpg": 74118,
	"./doctors/deepak-gowda.jpg": 29945,
	"./doctors/deeya.jpg": 81824,
	"./doctors/devaraj-m.jpg": 97058,
	"./doctors/dinesh.jpg": 76156,
	"./doctors/divyasre.jpg": 30522,
	"./doctors/divyasree.jpg": 91426,
	"./doctors/doctor_avatar_female.webp": 77244,
	"./doctors/dr-anjali-b-p.jpg": 64927,
	"./doctors/dr-anjali.jpg": 24915,
	"./doctors/dr-anuja.jpg": 96341,
	"./doctors/dr-anusha-new.JPG": 16637,
	"./doctors/dr-anusha.jpeg": 79809,
	"./doctors/dr-apoorva.png": 91833,
	"./doctors/dr-archana-d-v.png": 36375,
	"./doctors/dr-arpitha-new.JPG": 10400,
	"./doctors/dr-arpitha.jpg": 45151,
	"./doctors/dr-arvind-new.JPG": 76309,
	"./doctors/dr-aveen-new.JPG": 94464,
	"./doctors/dr-bharath-ban.jpeg": 5535,
	"./doctors/dr-bharath-ban1.jpeg": 55554,
	"./doctors/dr-bharath-ban1.jpg": 5114,
	"./doctors/dr-bharath.jpg": 56138,
	"./doctors/dr-bharathi-ramesh.png": 52590,
	"./doctors/dr-chandan-new.jpg": 89221,
	"./doctors/dr-chaya-s-m-new.png": 63500,
	"./doctors/dr-chethana-new.JPG": 80213,
	"./doctors/dr-deepak-kavandur.jpeg": 86626,
	"./doctors/dr-deeya-c-b.jpg": 1509,
	"./doctors/dr-divyashree-d-new.png": 18612,
	"./doctors/dr-geetha-eshwar-pillai.png": 91446,
	"./doctors/dr-geetha-new.png": 23134,
	"./doctors/dr-hema-h-r.png": 10638,
	"./doctors/dr-inchara-ben.jpeg": 44520,
	"./doctors/dr-inchara-ben1.jpg": 4611,
	"./doctors/dr-javgal-suraj-new.png": 53244,
	"./doctors/dr-jayashree-venkatesh-new.png": 21035,
	"./doctors/dr-kalyan-reddy.jpeg": 79935,
	"./doctors/dr-kalyan-reddy.jpg": 46732,
	"./doctors/dr-kishore-yeruru-new.png": 23540,
	"./doctors/dr-kshma-kamath.png": 23642,
	"./doctors/dr-kusuma.jpg": 36974,
	"./doctors/dr-leelavathi-new.JPG": 5048,
	"./doctors/dr-likhitha.jpg": 57439,
	"./doctors/dr-manjunath-mysore.jpg": 44523,
	"./doctors/dr-manjunatha-new.JPG": 50919,
	"./doctors/dr-nandini-ban.jpg": 64441,
	"./doctors/dr-nandini-patil.jpeg": 26623,
	"./doctors/dr-nanditha-nandakumar.jpg": 69572,
	"./doctors/dr-nanditha-new.JPG": 67006,
	"./doctors/dr-nanditha.jpg": 75822,
	"./doctors/dr-nivedita.png": 85130,
	"./doctors/dr-padmapriya-g-new.png": 73886,
	"./doctors/dr-padmapriya.jpg": 72723,
	"./doctors/dr-padmashree-nagraju.png": 20040,
	"./doctors/dr-pavitra-ramanagar.jpg": 79057,
	"./doctors/dr-pooja-new.JPG": 49673,
	"./doctors/dr-poonima-new.JPG": 39469,
	"./doctors/dr-prashanth-kumar.png": 94173,
	"./doctors/dr-prashanth-l-new.png": 27645,
	"./doctors/dr-praveen-new.JPG": 38219,
	"./doctors/dr-preethi-gowda-new.png": 55190,
	"./doctors/dr-preeti-allum.png": 81330,
	"./doctors/dr-priyanka-ravi.jpg": 19333,
	"./doctors/dr-priyanka-vijay-new.jpg": 11123,
	"./doctors/dr-punitha-new.jpg": 96453,
	"./doctors/dr-punnetha.jpg": 33081,
	"./doctors/dr-raghu-new.JPG": 44120,
	"./doctors/dr-ramapriya-kalkunte-new.png": 36978,
	"./doctors/dr-ramapriya-kalkunte-new1.jpeg": 5296,
	"./doctors/dr-ramya-prakash.png": 6581,
	"./doctors/dr-rashmi-kishor-new.JPG": 19889,
	"./doctors/dr-rashmi-new.JPG": 58607,
	"./doctors/dr-rashmi.jpg": 10502,
	"./doctors/dr-rasika-ravi-kumar.png": 66393,
	"./doctors/dr-ravi.jpg": 16250,
	"./doctors/dr-ravichandra-new.png": 73424,
	"./doctors/dr-raza-adoor.png": 39127,
	"./doctors/dr-sakolkar-shalmali-vilas.png": 54360,
	"./doctors/dr-sandhya-ban.jpeg": 95613,
	"./doctors/dr-sandhya-ban1.jpg": 23220,
	"./doctors/dr-seemasjmysore-new.png": 34512,
	"./doctors/dr-shahsikiran.jpg": 32092,
	"./doctors/dr-shalini-s-r.jpg": 22599,
	"./doctors/dr-shalini-s-r.png": 10738,
	"./doctors/dr-shashi-new.JPG": 18140,
	"./doctors/dr-shewtha-1.jpeg": 75212,
	"./doctors/dr-shewtha.jpg": 38974,
	"./doctors/dr-shilpa-mys.jpg": 74935,
	"./doctors/dr-shilpa-new.JPG": 56354,
	"./doctors/dr-shrithi.jpg": 59437,
	"./doctors/dr-shruthi-sh-new.png": 99794,
	"./doctors/dr-shruthi-sh.jpeg": 15621,
	"./doctors/dr-shubha-new.JPG": 85179,
	"./doctors/dr-spoorthi.jpg": 86249,
	"./doctors/dr-spurti-new.jpg": 36668,
	"./doctors/dr-srinath.png": 62941,
	"./doctors/dr-suman-new.png": 15053,
	"./doctors/dr-suman.jpg": 50817,
	"./doctors/dr-sunil-new.JPG": 76860,
	"./doctors/dr-sushma-new.JPG": 86271,
	"./doctors/dr-swathi-g.jpg": 16973,
	"./doctors/dr-tarangini.jpg": 77593,
	"./doctors/dr-taringini-durgappa-new.JPG": 48754,
	"./doctors/dr-thrupthi-new.JPG": 12963,
	"./doctors/dr-thrupthis.jpg": 594,
	"./doctors/dr-vandana.jpg": 94605,
	"./doctors/dr-veena-keerthi-new.jpeg": 77977,
	"./doctors/dr-veena-mysore.jpg": 40386,
	"./doctors/dr-veena-new.JPG": 75112,
	"./doctors/dr.madhusoodhan-new.jpeg": 92345,
	"./doctors/dr.priyanka.jpg": 79904,
	"./doctors/dr.sowmyaa.png": 22741,
	"./doctors/dr.sreeharsha.jpg": 2977,
	"./doctors/dr.suman.jpg": 48244,
	"./doctors/dr.varsha.jpg": 83500,
	"./doctors/dr.yeshoda-k-new.png": 66805,
	"./doctors/drSHREYASALVA.png": 42027,
	"./doctors/dr_aathira_ravindranath.jpg": 90626,
	"./doctors/drarunraykarnew.png": 29934,
	"./doctors/drashmitha-new.png": 71646,
	"./doctors/drbalaji-01.jpg": 80410,
	"./doctors/drbalajikc-01.jpg": 49362,
	"./doctors/drkavitakomandur.png": 4394,
	"./doctors/drmanjunath.jpg": 58414,
	"./doctors/drmanjunath1.jpg": 3670,
	"./doctors/drnarendrababunew.png": 48635,
	"./doctors/drnitinnayaknew.png": 53416,
	"./doctors/drparaasuraman.png": 79927,
	"./doctors/drpremalatha.jpeg": 10869,
	"./doctors/drramya-new.png": 1193,
	"./doctors/drrevati-new.png": 3034,
	"./doctors/drsahanan-new.png": 34896,
	"./doctors/drsumanthkumar.png": 31905,
	"./doctors/ekatha-c-n.png": 64930,
	"./doctors/femaledoc.png": 81764,
	"./doctors/gangam-new.jpg": 86922,
	"./doctors/gangam.jpg": 24342,
	"./doctors/geetha-pillai-1.jpg": 14199,
	"./doctors/geetha-pillai.jpg": 48848,
	"./doctors/harshitha-ramnagara.jpg": 63222,
	"./doctors/hema-h-r-new.jpg": 38594,
	"./doctors/hema-h-r-new1.jpeg": 63592,
	"./doctors/hema-h-r.jpg": 18990,
	"./doctors/hemalatha-ramanagar.jpg": 31902,
	"./doctors/indushree.jpeg": 16130,
	"./doctors/ishwarya.jpg": 5897,
	"./doctors/jacqueline-shah.jpg": 20405,
	"./doctors/jalajakshi.jpg": 39829,
	"./doctors/jamunashree.jpeg": 68190,
	"./doctors/javagal-s-suraj.jpg": 24076,
	"./doctors/jaya-kiran-new.jpg": 92271,
	"./doctors/jaya-kiran.png": 86317,
	"./doctors/jayanthi-durganna.jpg": 41998,
	"./doctors/jayanthi-new.png": 77246,
	"./doctors/jayanthi.jpg": 91782,
	"./doctors/jayashree.jpg": 57372,
	"./doctors/joewin-monteiro.jpg": 8699,
	"./doctors/kalyan-reddy.png": 63354,
	"./doctors/kav.jpg": 57624,
	"./doctors/kavitha-dental.jpeg": 66334,
	"./doctors/kavya-t.jpg": 6757,
	"./doctors/kavya.jpg": 82099,
	"./doctors/kavya_diet.jpg": 43622,
	"./doctors/kavyakrishnappa.jpg": 45962,
	"./doctors/kckavitha.jpg": 58713,
	"./doctors/keerthi-rajendra.jpg": 81368,
	"./doctors/kishore-yerur-new.jpg": 76376,
	"./doctors/kishore-yerur.jpg": 52589,
	"./doctors/kshama-kamath.jpg": 84714,
	"./doctors/kshma-kmth-new.png": 55516,
	"./doctors/lakshmi-dr.jpg": 12444,
	"./doctors/lakshmi-dr1.jpg": 41344,
	"./doctors/laxman-dr.jpg": 97421,
	"./doctors/leelvathi.jpg": 23857,
	"./doctors/leelvathi1.jpg": 60330,
	"./doctors/likhitha-ban.jpeg": 20642,
	"./doctors/likita-doc.png": 98112,
	"./doctors/lokeshwari-1.jpeg": 89220,
	"./doctors/lokeshwari-22.webp": 15719,
	"./doctors/lokeshwari.jpg": 80376,
	"./doctors/madhu-muddaiha.jpg": 4945,
	"./doctors/madhu-muddaihaa.jpeg": 14555,
	"./doctors/madhu-naidu.jpg": 21040,
	"./doctors/madhu-ramanagara.jpg": 44766,
	"./doctors/madhu.jpg": 8434,
	"./doctors/madhusoodan-old.jpg": 47901,
	"./doctors/madhusoodan.jpg": 76865,
	"./doctors/manasa-c.jpg": 96861,
	"./doctors/manjunatha.jpg": 5490,
	"./doctors/manjush-halbhavi.jpg": 11133,
	"./doctors/manjusha-nambiar.jpg": 27312,
	"./doctors/manjusha1.jpg": 36110,
	"./doctors/meena-b-m.jpg": 50101,
	"./doctors/meena-bm.png": 2754,
	"./doctors/mohit-m-1.webp": 5075,
	"./doctors/mohit-m.jpg": 6272,
	"./doctors/mr-arvind.png": 58004,
	"./doctors/nagarathnamma.jpg": 6955,
	"./doctors/nagendra-kumar-new.png": 18700,
	"./doctors/nagendra-kumar.jpg": 91409,
	"./doctors/nagendra-prasad.jpg": 67250,
	"./doctors/nandini-doc.png": 1028,
	"./doctors/nandita1.jpg": 89910,
	"./doctors/nanditha-m.jpg": 94654,
	"./doctors/narendra-babu.jpg": 39371,
	"./doctors/naveen-k-s.jpg": 57489,
	"./doctors/navneeth.jpg": 82505,
	"./doctors/neethu-priya-k.jpeg": 53034,
	"./doctors/niby-j-elackatt.jpg": 55469,
	"./doctors/nirmal-raj.jpg": 70430,
	"./doctors/nirmal1.jpg": 19477,
	"./doctors/nishan.jpg": 42185,
	"./doctors/nithin-r.jpeg": 98439,
	"./doctors/nitin-nayak.jpg": 44923,
	"./doctors/padmapriya-new.png": 53997,
	"./doctors/padmashree-doc-kc.jpg": 25526,
	"./doctors/pallavi.jpg": 62829,
	"./doctors/pallavi1.jpg": 27683,
	"./doctors/pavi.jpg": 70794,
	"./doctors/pooja_n_swamy.jpg": 53531,
	"./doctors/poornima.jpg": 87810,
	"./doctors/prabhakaran.jpg": 17035,
	"./doctors/prakash-babu.jpg": 85067,
	"./doctors/pramod-new.png": 77931,
	"./doctors/pramod.jpg": 16425,
	"./doctors/pramod.png": 64290,
	"./doctors/prashanth-inna.jpg": 93407,
	"./doctors/prashanth.jpg": 21301,
	"./doctors/praveen-n.jpeg": 69423,
	"./doctors/praveen.jpg": 91590,
	"./doctors/praveez-ahmed.jpg": 17951,
	"./doctors/preethi-allum.jpg": 51303,
	"./doctors/preethi-gowda.jpg": 3460,
	"./doctors/premalatha.jpeg": 16706,
	"./doctors/priyanka-new.jpg": 15129,
	"./doctors/priyanka.jpg": 9464,
	"./doctors/puspanjali-ramanagara.jpg": 73739,
	"./doctors/raghu.jpeg": 6214,
	"./doctors/rajeshwari-s.jpg": 65925,
	"./doctors/rakesh-mysore.jpeg": 60896,
	"./doctors/ramapriya-kalkunte.jpg": 44500,
	"./doctors/rame-gowda.JPG": 81357,
	"./doctors/rame-gowda.png": 83271,
	"./doctors/ramya_shankar.jpg": 92568,
	"./doctors/ranjitha-new.png": 864,
	"./doctors/rashmi-kishore.png": 8903,
	"./doctors/rashmi-t-s-new.jpg": 12679,
	"./doctors/rashmiKishore.jpeg": 13639,
	"./doctors/rashmiKishore.jpg": 66210,
	"./doctors/rashmikishore-01.jpg": 33217,
	"./doctors/rasika.jpeg": 1579,
	"./doctors/ravi-hiremagalur.png": 64668,
	"./doctors/ravichandra.jpg": 13046,
	"./doctors/revathi.png": 67356,
	"./doctors/roopa-pateel-dr.jpg": 59893,
	"./doctors/sabeena-taj.jpg": 59560,
	"./doctors/sachin-dharwadkar.jpg": 31817,
	"./doctors/sagetya.jpg": 60938,
	"./doctors/sahana-ramanagara.jpg": 33001,
	"./doctors/sahana.png": 68756,
	"./doctors/santhosh-ramanagara.jpg": 71898,
	"./doctors/santhosh_kumar.jpeg": 70232,
	"./doctors/santhoshkumar-1.jpeg": 92141,
	"./doctors/santosh-olety-sathyanarayana.jpg": 75318,
	"./doctors/saraswati-vishwanatha.png": 86649,
	"./doctors/saraswati-viswanathan.jpg": 97904,
	"./doctors/sathish-babu.jpg": 90310,
	"./doctors/satosh-babu-new.png": 6136,
	"./doctors/satosh-babu-new1.png": 6876,
	"./doctors/shalini-narayan.jpg": 65787,
	"./doctors/shalini-new.jpg": 63456,
	"./doctors/shalmali-old.jpg": 21630,
	"./doctors/shalmali.jpeg": 20322,
	"./doctors/shalmali.jpg": 52468,
	"./doctors/shankar-singh.jpg": 95322,
	"./doctors/shasthara.jpg": 69749,
	"./doctors/shekar-subbaiah-new.jpeg": 10993,
	"./doctors/shekar-subbaiah-old.jpg": 46906,
	"./doctors/shekar-subbaiah.jpeg": 19224,
	"./doctors/shekar-subbaiah.jpg": 39901,
	"./doctors/shilpa-nadig.jpeg": 53718,
	"./doctors/shilpa_n_vijay.jpg": 53594,
	"./doctors/shivachandra.jpg": 98336,
	"./doctors/shreenath-bangalore.jpg": 11142,
	"./doctors/shreyas.jpg": 21662,
	"./doctors/shristi-v.png": 44864,
	"./doctors/shruthi-ramanagar.jpg": 43340,
	"./doctors/shubha-mysore.jpg": 72824,
	"./doctors/shwetha-b-m.jpeg": 90804,
	"./doctors/siddarth_warad.jpeg": 97486,
	"./doctors/siri-gowri-s.jpeg": 11558,
	"./doctors/smita.jpg": 26084,
	"./doctors/smitha-shetty.jpg": 22460,
	"./doctors/sneha1.jpg": 84064,
	"./doctors/soumya-arudi-nagarajan.jpg": 83024,
	"./doctors/soumya-jpg.jpg": 61696,
	"./doctors/spurtii.jpeg": 15,
	"./doctors/spurtii.jpg": 88506,
	"./doctors/sree-harsha.png": 47509,
	"./doctors/srushti.jpg": 54248,
	"./doctors/subramya-new.jpg": 57161,
	"./doctors/subramya.jpg": 87410,
	"./doctors/suchitra-sl.jpg": 29988,
	"./doctors/sumalatha_k_b.jpeg": 15203,
	"./doctors/suman-r-k.jpg": 95140,
	"./doctors/sunayana-nagendra-s-1.jpg": 4924,
	"./doctors/sunayana-nagendra-s.jpg": 87853,
	"./doctors/suneel.jpg": 42865,
	"./doctors/suneetha.jpeg": 64241,
	"./doctors/sunil-mysore-new.jpg": 67937,
	"./doctors/supriya-bhandage.jpeg": 71360,
	"./doctors/sushma.jpg": 74612,
	"./doctors/sushmitha-r.png": 56332,
	"./doctors/swaroop.jpeg": 94121,
	"./doctors/swathi-g-new.png": 6211,
	"./doctors/swathi-g-old.png": 36506,
	"./doctors/swathi-g.png": 52323,
	"./doctors/swathi1.jpg": 66750,
	"./doctors/swatihkmysore-new.png": 21489,
	"./doctors/tarun-javeli.jpeg": 67940,
	"./doctors/testDoctor.png": 20458,
	"./doctors/thrupthi-new.jpg": 86199,
	"./doctors/tripti-mirza-new.jpg": 5663,
	"./doctors/trupti-1.jpg": 77643,
	"./doctors/varun-new.jpg": 89125,
	"./doctors/varun_ramnagara.jpg": 45300,
	"./doctors/veena.jpg": 82515,
	"./doctors/veerendarsingh-b.jpeg": 9733,
	"./doctors/vibha.jpg": 16408,
	"./doctors/vibha1.jpg": 3435,
	"./doctors/vinay-ja.jpg": 93133,
	"./doctors/vinay-jadh.png": 13531,
	"./doctors/vinay-jadhav.jpg": 14579,
	"./doctors/vykunta-raju-new.jpg": 87608,
	"./doctors/vykunta-raju.jpg": 68434,
	"./doctors/vyshakha-chikkanagoudar.png": 47742,
	"./doctors/yashaswini.jpg": 56612,
	"./doctors/yashaswini1.jpg": 59897,
	"./doctors/yashodha-k-n.jpg": 94563,
	"./downloads-bg.jpg": 35495,
	"./downloads-bg.webp": 67622,
	"./error.jpg": 49235,
	"./events-full.jpg": 72082,
	"./facilities-kc.jpg": 19987,
	"./facilities-kc.webp": 55078,
	"./feature/01.png": 80303,
	"./feature/02.png": 57591,
	"./feature/03.png": 97690,
	"./founders/dr-manjunath-new.jpg": 75723,
	"./founders/dr-manjunath-new2.jpg": 75129,
	"./founders/drmanjunath.jpg": 21666,
	"./founders/drmanjunath11.jpg": 26663,
	"./founders/drmanjunath12.jpg": 24356,
	"./founders/javgal-s-suraj.jpg": 84862,
	"./founders/praveen-k-john.jpg": 49423,
	"./founders/ramapriyya-kalkunte.jpg": 16312,
	"./founders/shekar-subbaiah-new.jpeg": 31255,
	"./founders/shekhar-subbaiah.jpg": 38555,
	"./founders/shekhar-subbaiah1.jpg": 12302,
	"./fw3.png": 34352,
	"./gallery-bg.jpg": 2836,
	"./gallery-bg.webp": 16464,
	"./gallery/breaking-down.jpg": 75023,
	"./gallery/child-development.jpg": 36436,
	"./gallery/childs-nutrition-and-digestion.jpg": 62239,
	"./gallery/complex-cases.jpg": 76983,
	"./gallery/kats-ambulance.jpg": 7487,
	"./gallery/mom-baby.jpg": 92483,
	"./gallery/pediatric-surgery.jpeg": 38032,
	"./gallery/pics/1.jpg": 96963,
	"./gallery/pics/10.jpg": 52133,
	"./gallery/pics/11.jpg": 85619,
	"./gallery/pics/12.jpg": 77553,
	"./gallery/pics/13.jpg": 34174,
	"./gallery/pics/14.jpg": 92225,
	"./gallery/pics/15.jpg": 55474,
	"./gallery/pics/16.jpg": 22831,
	"./gallery/pics/17.jpg": 30567,
	"./gallery/pics/18.jpg": 82917,
	"./gallery/pics/19.jpg": 92161,
	"./gallery/pics/1_old.jpg": 59312,
	"./gallery/pics/1st floor-ip-department-9.png": 14817,
	"./gallery/pics/2.jpg": 87607,
	"./gallery/pics/20.jpg": 12074,
	"./gallery/pics/21.jpg": 73978,
	"./gallery/pics/22.jpg": 13737,
	"./gallery/pics/23.jpg": 75380,
	"./gallery/pics/24.jpg": 53197,
	"./gallery/pics/25.jpg": 19,
	"./gallery/pics/26.jpg": 59471,
	"./gallery/pics/27.jpg": 18314,
	"./gallery/pics/28.jpg": 64174,
	"./gallery/pics/29.jpg": 20152,
	"./gallery/pics/2nd-floor-ip-department-10.png": 39601,
	"./gallery/pics/3.jpg": 28242,
	"./gallery/pics/30.jpg": 26689,
	"./gallery/pics/4.jpg": 99918,
	"./gallery/pics/5.jpg": 98204,
	"./gallery/pics/6.jpg": 15125,
	"./gallery/pics/7.jpg": 77495,
	"./gallery/pics/8.jpg": 84113,
	"./gallery/pics/9.jpg": 15828,
	"./gallery/pics/Baby Shop.jpg": 95923,
	"./gallery/pics/HDU.jpg": 2795,
	"./gallery/pics/InPatient Area.jpg": 62784,
	"./gallery/pics/InPatient Lobby.jpg": 64522,
	"./gallery/pics/LDU.jpg": 12235,
	"./gallery/pics/Main Lobby.jpg": 75087,
	"./gallery/pics/Neonatal Transport Incubator.jpg": 5210,
	"./gallery/pics/Operation Theatre.jpg": 31059,
	"./gallery/pics/Outpatient Department.jpg": 66422,
	"./gallery/pics/Private Room.jpg": 15154,
	"./gallery/pics/Radiology.jpg": 46793,
	"./gallery/pics/Reception.jpg": 12153,
	"./gallery/pics/SICU.jpg": 67368,
	"./gallery/pics/Semi Suit Room.jpg": 39130,
	"./gallery/pics/Suit Room.jpg": 17342,
	"./gallery/pics/baby-shop-4.png": 56190,
	"./gallery/pics/bangalore-old.jpg": 85635,
	"./gallery/pics/bangalore.jpg": 93043,
	"./gallery/pics/chili-pili-banner.jpg": 35173,
	"./gallery/pics/clinics-banner.jpg": 73475,
	"./gallery/pics/conference-room-bng-1.png": 73018,
	"./gallery/pics/dental.jpg": 99851,
	"./gallery/pics/dentistry-banner.webp": 78148,
	"./gallery/pics/diamond-12.png": 8676,
	"./gallery/pics/fertility-old.jpg": 2485,
	"./gallery/pics/fertility.jpg": 41383,
	"./gallery/pics/first-foot-imprint-ban.jpg": 27028,
	"./gallery/pics/first-foot-imprint-mys.jpg": 73800,
	"./gallery/pics/hospital-1.png": 47088,
	"./gallery/pics/hospital-bng.jpg": 9225,
	"./gallery/pics/kids-banner.png": 29371,
	"./gallery/pics/kids-web-banner.jpg": 38922,
	"./gallery/pics/main-lobby-2.png": 67224,
	"./gallery/pics/mysore-new/1st floor-OPdepartment.png": 34558,
	"./gallery/pics/mysore-new/Your paragraph text (13).jpg": 88257,
	"./gallery/pics/mysore-new/Your paragraph text (19).jpg": 96499,
	"./gallery/pics/mysore-new/Your paragraph text (5).jpg": 60608,
	"./gallery/pics/mysore-new/Your paragraph text.jpg": 64406,
	"./gallery/pics/mysore-new/aerobic-3391.jpg": 32887,
	"./gallery/pics/mysore-new/baby-shop-and-himalaya-3265.jpg": 51892,
	"./gallery/pics/mysore-new/cafeteria.png": 75470,
	"./gallery/pics/mysore-new/first-floor-ip-department-9590.jpg": 56698,
	"./gallery/pics/mysore-new/first-floor-op-department-3315.jpg": 80187,
	"./gallery/pics/mysore-new/hospital.png": 80520,
	"./gallery/pics/mysore-new/lab-9638.jpg": 74529,
	"./gallery/pics/mysore-new/library-9624.jpg": 21977,
	"./gallery/pics/mysore-new/main-lobby-3257.jpg": 4450,
	"./gallery/pics/mysore-new/nicu-in-born-3492.jpg": 81867,
	"./gallery/pics/mysore-new/nicu-outborn-3484.jpg": 35914,
	"./gallery/pics/mysore-new/obg-opd-3286.jpg": 37844,
	"./gallery/pics/mysore-new/obg-opd.png": 11255,
	"./gallery/pics/mysore-new/opd-9544.jpg": 27202,
	"./gallery/pics/mysore-new/pharmacy.png": 40882,
	"./gallery/pics/mysore-new/radiology-9559.jpg": 66258,
	"./gallery/pics/mysore-new/reception-3273.jpg": 59276,
	"./gallery/pics/mysore-new/reception.png": 53006,
	"./gallery/pics/mysore-new/second-floor-ip-department-9608.jpg": 43919,
	"./gallery/pics/mysore-new/sicu-3375.jpg": 97594,
	"./gallery/pics/mysore-new/triage-3414.jpg": 47395,
	"./gallery/pics/mysore-new/twin-sharing-3512.jpg": 53888,
	"./gallery/pics/mysore-new/yoga-room.png": 43358,
	"./gallery/pics/mysore.jpg": 93501,
	"./gallery/pics/nescafe.jpg": 19541,
	"./gallery/pics/nicu-21.png": 64717,
	"./gallery/pics/nicu.jpg": 92297,
	"./gallery/pics/obg-opd-7.png": 32566,
	"./gallery/pics/operation-theater-17.png": 33913,
	"./gallery/pics/paediatric-opd-8.png": 89402,
	"./gallery/pics/pharmacy-6.png": 51660,
	"./gallery/pics/photo-studio.jpg": 69093,
	"./gallery/pics/ramanagar-banner.jpg": 55916,
	"./gallery/pics/ramanagar-banner1.jpg": 20466,
	"./gallery/pics/ramanagara/inside-hospital.jpg": 76078,
	"./gallery/pics/ramanagara/lobby-1.jpg": 60150,
	"./gallery/pics/ramanagara/lobby-2.jpg": 15293,
	"./gallery/pics/ramanagara/main-entrance.jpg": 23188,
	"./gallery/pics/ramanagara/main-gate.jpg": 15115,
	"./gallery/pics/ramanagara/main-reception.jpg": 96979,
	"./gallery/pics/ramanagara/main_entrance.jpg": 76963,
	"./gallery/pics/ramanagara/main_gate.jpg": 6668,
	"./gallery/pics/ramanagara/new/IP-department.png": 20447,
	"./gallery/pics/ramanagara/new/NICU.png": 4107,
	"./gallery/pics/ramanagara/new/OBG-OPD.png": 739,
	"./gallery/pics/ramanagara/new/SICU-&-HDU.png": 64920,
	"./gallery/pics/ramanagara/new/aerobics-room.jpg": 67846,
	"./gallery/pics/ramanagara/new/baby-shop.jpg": 33265,
	"./gallery/pics/ramanagara/new/baby-shop.png": 63251,
	"./gallery/pics/ramanagara/new/cafeteria.jpg": 3687,
	"./gallery/pics/ramanagara/new/cafeteria.png": 63882,
	"./gallery/pics/ramanagara/new/conference-room.jpg": 46434,
	"./gallery/pics/ramanagara/new/doctors-lounge.jpg": 4256,
	"./gallery/pics/ramanagara/new/first-foot-imprint-ram.jpg": 17324,
	"./gallery/pics/ramanagara/new/first-imprints.jpg": 56977,
	"./gallery/pics/ramanagara/new/hospital.jpg": 11646,
	"./gallery/pics/ramanagara/new/hospital.png": 90889,
	"./gallery/pics/ramanagara/new/ip-biling.jpg": 62434,
	"./gallery/pics/ramanagara/new/laboratory.jpg": 47425,
	"./gallery/pics/ramanagara/new/main-lobby.jpg": 85514,
	"./gallery/pics/ramanagara/new/nicu.jpg": 20048,
	"./gallery/pics/ramanagara/new/nursing-station.jpg": 30945,
	"./gallery/pics/ramanagara/new/nursing-station.png": 9376,
	"./gallery/pics/ramanagara/new/obg-opd.jpg": 20860,
	"./gallery/pics/ramanagara/new/ot.jpg": 68342,
	"./gallery/pics/ramanagara/new/peadiatrics-opd.jpg": 61104,
	"./gallery/pics/ramanagara/new/pharmacy.jpg": 58642,
	"./gallery/pics/ramanagara/new/photo-studio-ram.jpg": 17995,
	"./gallery/pics/ramanagara/new/platinumroom.png": 35504,
	"./gallery/pics/ramanagara/new/private-room.jpg": 76093,
	"./gallery/pics/ramanagara/new/radiology.jpg": 30721,
	"./gallery/pics/ramanagara/new/radiology.png": 37169,
	"./gallery/pics/ramanagara/new/reception.jpg": 34350,
	"./gallery/pics/ramanagara/new/shared-room.jpg": 48909,
	"./gallery/pics/ramanagara/new/sicu.jpg": 50334,
	"./gallery/pics/ramanagara/new/studio.jpg": 30937,
	"./gallery/pics/ramanagara/new/suite-room.jpg": 88533,
	"./gallery/pics/ramanagara/new/triage.jpg": 45396,
	"./gallery/pics/ramanagara/new/triage.png": 94770,
	"./gallery/pics/ramanagara/our-journey.jpg": 56265,
	"./gallery/pics/ramanagara/reception.jpg": 33398,
	"./gallery/pics/ramanagara/ward-room.jpg": 81015,
	"./gallery/pics/ramanagara/ward.jpg": 59178,
	"./gallery/pics/ramnagar-1.jpg": 52318,
	"./gallery/pics/ramnagar-2.jpg": 42113,
	"./gallery/pics/ramnagar-3.jpg": 54823,
	"./gallery/pics/ramnagar-4.jpg": 24167,
	"./gallery/pics/ramnagar-5.jpg": 95094,
	"./gallery/pics/ramnagar-6.jpg": 44006,
	"./gallery/pics/ramnagar-7.jpg": 82362,
	"./gallery/pics/ramnagar-8.jpg": 65050,
	"./gallery/pics/ramnagar_banner.jpg": 40779,
	"./gallery/pics/reception-3.png": 47993,
	"./gallery/pics/triage-5.png": 64722,
	"./gallery/pics/tumakuru/Baby Shop.jpg": 10601,
	"./gallery/pics/tumakuru/Hospital.jpg": 47164,
	"./gallery/pics/tumakuru/Kids .jpg": 64662,
	"./gallery/pics/tumakuru/NICU.jpg": 90849,
	"./gallery/pics/tumakuru/Private.jpg": 56585,
	"./gallery/pics/tumakuru/Reception.jpg": 36683,
	"./gallery/pics/tumakuru/SICU.jpg": 8293,
	"./gallery/pics/tumakuru/Semi Suite.jpg": 62655,
	"./gallery/pics/tumakuru/Suite .jpg": 90966,
	"./gallery/pics/tumakuru/Tumakuru Cafeteria.jpg": 83325,
	"./gallery/pics/tumakuru/labour.jpg": 70241,
	"./gallery/pics/tumakuru/operation theater .jpg": 72904,
	"./gallery/pics/tumakuru/studio.JPEG": 8093,
	"./gallery/pics/tumakuru/twin-sharing..jpg": 85189,
	"./gallery/together-we-did.jpg": 3368,
	"./gallery/with-baby.jpg": 13998,
	"./gallery/wonder-baby.jpg": 60990,
	"./gallery/world-prematurity-day.jpg": 43021,
	"./heart.png": 59125,
	"./home-tab-01.png": 21541,
	"./home-tab-01.webp": 22637,
	"./home-tab-02.png": 56979,
	"./home-tab-02.webp": 60664,
	"./home-tab-03.png": 43193,
	"./home-tab-03.webp": 96769,
	"./home-tab-04.png": 46550,
	"./home-tab-04.webp": 56928,
	"./home-tab-05.png": 64830,
	"./home-tab-05.webp": 7972,
	"./home-tab-06.png": 4179,
	"./home-tab-06.webp": 7325,
	"./home-tab-image-01.png": 32792,
	"./home-tab-image-01.webp": 95386,
	"./home-tab-image-02.png": 13594,
	"./home-tab-image-02.webp": 63695,
	"./home-tab-image-03.jpg": 90973,
	"./home-tab-image-03.webp": 89976,
	"./home-tab-image-04.jpg": 32740,
	"./home-tab-image-04.webp": 97005,
	"./home-tab-image-05.jpg": 75291,
	"./home-tab-image-05.webp": 18433,
	"./home-tab-image-06.jpg": 15319,
	"./home-tab-image-06.webp": 93798,
	"./icons/cancel-white.png": 90659,
	"./icons/cancel.png": 63797,
	"./icons/coloredbg.png": 97202,
	"./icons/loader.gif": 64637,
	"./icons/quote.png": 80719,
	"./image-content-box1.png": 19141,
	"./image-content-box1.webp": 99036,
	"./image-content-box2.png": 12310,
	"./image-content-box2.webp": 6435,
	"./job-1.png": 94762,
	"./job-2.png": 18538,
	"./job1.jpg": 27609,
	"./job2.jpg": 91914,
	"./jobsection-1.jpg": 13759,
	"./jobsection-2.jpg": 10178,
	"./journey-new.jpg": 51757,
	"./kangaroo-care-new-logo.png": 86053,
	"./kats-new-1.png": 32171,
	"./kats-new.jpg": 43787,
	"./kats-round.png": 55187,
	"./kats-round.webp": 59871,
	"./kats.jpg": 56144,
	"./kats.webp": 92460,
	"./katsbannerimage.jpg": 30200,
	"./kc-journey-new.jpg": 65093,
	"./kc-logo-header.png": 89953,
	"./kc-logo-pink.png": 31481,
	"./kclogo-01-01.png": 5199,
	"./loadier.gif": 71341,
	"./loading.gif": 60265,
	"./logo-dark.png": 98750,
	"./logo.png": 15080,
	"./map-for--banner-for-journey.jpg": 42057,
	"./map-for--banner-for-journey1.jpg": 75270,
	"./map-for-web-new.jpg": 11813,
	"./map-for-web.jpg": 87727,
	"./media/camp/10_camp.jpg": 93983,
	"./media/camp/2_5_camp.jpg": 81287,
	"./media/camp/4_3_camp.jpg": 89939,
	"./media/camp/5_camp.jpg": 36611,
	"./media/camp/Camp.jpg": 28779,
	"./media/camp/camp-1.jpg": 70290,
	"./media/camp/camp-2.jpg": 68116,
	"./media/camp/camp-4.png": 25668,
	"./media/camp/camp-banner.jpg": 95454,
	"./media/camp/camp-new-1.png": 36859,
	"./media/camp/camp-new-2.png": 42438,
	"./media/camp/camp-school.jpeg": 28308,
	"./media/camp/camp_11.jpg": 27386,
	"./media/camp/camp_13.jpg": 70887,
	"./media/camp/camp_14.jpg": 49253,
	"./media/camp/camp_15.jpg": 74457,
	"./media/camp/camp_16.jpg": 20382,
	"./media/camp/camp_17.jpg": 14611,
	"./media/camp/camp_18.jpg": 39771,
	"./media/camp/camp_5.jpeg": 41425,
	"./media/camp/camp_5.jpg": 41172,
	"./media/camp/camp_6.jpg": 2593,
	"./media/camp/cmap_12.jpg": 39830,
	"./media/camp/fertility-camp.png": 32196,
	"./media/camp/health-check-upp.jpg": 9681,
	"./media/camp/health-checkup-camp-ramanagara.jpg": 40918,
	"./media/downloads/about-kangaroo-care.png": 15303,
	"./media/downloads/about-kc.jpg": 66776,
	"./media/downloads/child-development-clinic.png": 63155,
	"./media/downloads/childdevelopmetclinic.png 2.png": 48929,
	"./media/downloads/diet-for-expecting-moms.jpg": 48189,
	"./media/downloads/diet-plain.jpg": 75597,
	"./media/downloads/download-sec-2.jpg": 52920,
	"./media/downloads/download-sec-2.webp": 19062,
	"./media/downloads/download-sec-3.jpg": 64411,
	"./media/downloads/download-sec-3.webp": 54944,
	"./media/downloads/download-sec-4.jpg": 24334,
	"./media/downloads/download-sec-4.webp": 22962,
	"./media/downloads/download-sec-5.jpg": 62670,
	"./media/downloads/download-sec-5.webp": 7621,
	"./media/downloads/download-sec-6.jpg": 43393,
	"./media/downloads/download-sec-6.webp": 73073,
	"./media/downloads/download-sec-7.jpg": 99205,
	"./media/downloads/download-sec-7.webp": 20528,
	"./media/downloads/new-born-hearing-test.png": 37655,
	"./media/downloads/new-born-screening-test.png": 59917,
	"./media/downloads/newsletter.jpg": 61265,
	"./media/downloads/pain-relief.png": 19627,
	"./media/downloads/pain-relif-in-labour.jpg": 52856,
	"./media/downloads/pediatric-gastroenterology-clinic.png": 34821,
	"./media/downloads/pregnancy-yoga.jpg": 76560,
	"./media/events/08-feb-17-events.jpg": 99849,
	"./media/events/1.jpg": 1910,
	"./media/events/10.jpg": 87822,
	"./media/events/11.jpg": 3342,
	"./media/events/11_events.jpg": 86098,
	"./media/events/12.jpg": 34119,
	"./media/events/13.jpg": 34186,
	"./media/events/14.jpeg": 56966,
	"./media/events/15.jpg": 14378,
	"./media/events/16.jpg": 89629,
	"./media/events/17-dec-17-events.jpg": 62403,
	"./media/events/17.jpg": 37526,
	"./media/events/18.jpg": 5216,
	"./media/events/19.jpg": 91619,
	"./media/events/2.jpg": 91301,
	"./media/events/20.jpg": 72541,
	"./media/events/21.jpg": 80669,
	"./media/events/22-dec-17-events.jpg": 21557,
	"./media/events/22.jpg": 8459,
	"./media/events/23.jpg": 72957,
	"./media/events/24.jpg": 48634,
	"./media/events/25.jpg": 7878,
	"./media/events/26.jpg": 97560,
	"./media/events/29-dec-17-events.jpg": 53235,
	"./media/events/3.jpg": 82058,
	"./media/events/370_240_events.jpg": 73497,
	"./media/events/39.jpg": 51681,
	"./media/events/3_3_events.jpg": 32260,
	"./media/events/4.jpg": 58613,
	"./media/events/41.jpg": 30483,
	"./media/events/44.jpg": 42870,
	"./media/events/47.jpg": 62792,
	"./media/events/5.jpg": 20752,
	"./media/events/6.jpg": 30272,
	"./media/events/6_events.jpg": 4806,
	"./media/events/7.jpg": 45694,
	"./media/events/70-independence-day.jpg": 69403,
	"./media/events/70-independence-day1.jpg": 12010,
	"./media/events/7_events.jpg": 9129,
	"./media/events/8.jpg": 60460,
	"./media/events/8_events.jpg": 90771,
	"./media/events/9-may-17-events.jpg": 83082,
	"./media/events/9.jpg": 7174,
	"./media/events/BLS-Mock-Drill.jpg": 21245,
	"./media/events/Basic-life-support-training.jpg": 63356,
	"./media/events/Breast feeding week.jpg": 43759,
	"./media/events/CME-Dharawad.jpg": 26950,
	"./media/events/Community-Service.jpg": 59759,
	"./media/events/Employees-Induction-Program.jpg": 94242,
	"./media/events/Ganesh-Chaturthi-Celebration.jpg": 44635,
	"./media/events/NABH-Infection-control-training.jpg": 49914,
	"./media/events/NABH-training.jpg": 84633,
	"./media/events/Participated-in-Neonatology-and-Perinataolgy-panel-discussion.jpg": 1321,
	"./media/events/Planet-kids-campaign.jpg": 33925,
	"./media/events/VCN-doctors-meeting.jpg": 94679,
	"./media/events/antinatal-workshops.jpg": 89659,
	"./media/events/baby-94.jpeg": 14512,
	"./media/events/baby-shower-1.jpg": 5289,
	"./media/events/baby-shower-bangalore.jpg": 50985,
	"./media/events/baby-shower-ram-june28.jpg": 98789,
	"./media/events/baby-shower.jpg": 60783,
	"./media/events/babyshowerevent-1.jpg": 71270,
	"./media/events/babyshowerevent-2.jpg": 75175,
	"./media/events/bng.jpg": 95434,
	"./media/events/celebration-cd.jpg": 78051,
	"./media/events/celebration-cd.png": 59433,
	"./media/events/childvaccination-01.jpg": 58273,
	"./media/events/clinic-nagara-2.jpg": 80968,
	"./media/events/clinic-nagara-3.jpg": 28667,
	"./media/events/clinic-nagara-4.jpg": 68483,
	"./media/events/dentistry.jpg": 40723,
	"./media/events/doc-day.jpeg": 78015,
	"./media/events/doctors-july1st.jpg": 82221,
	"./media/events/event-1.jpg": 26588,
	"./media/events/event-3.jpg": 90073,
	"./media/events/event-A-30-1ug-2019.png": 20281,
	"./media/events/event-B-30-1ug-2019.png": 19749,
	"./media/events/event-banner.jpg": 89664,
	"./media/events/event-new-1.png": 83355,
	"./media/events/event-new-2.png": 44816,
	"./media/events/event-new-3.png": 41597,
	"./media/events/event-new-5.png": 76611,
	"./media/events/event-new-6.png": 86854,
	"./media/events/event-new-7.png": 33971,
	"./media/events/event-new-8.png": 7001,
	"./media/events/event-yoga-day.jpg": 97270,
	"./media/events/female-bikers-in-town.jpg": 20921,
	"./media/events/grand-inauguration-ceremony.jpg": 82979,
	"./media/events/health-checkup-ramanagara.jpg": 65145,
	"./media/events/kc-95.jpeg": 41976,
	"./media/events/mys.jpg": 73089,
	"./media/events/nagarabhavi-clinic.jpg": 36715,
	"./media/events/national-gastroneocon.jpg": 81574,
	"./media/events/news-letter-launch-1.png": 56626,
	"./media/events/news-letter-launch-2.png": 22507,
	"./media/events/nurse-day.jpg": 92619,
	"./media/events/nurses-quiz-competition.jpg": 59858,
	"./media/events/onam-celebration.jpg": 25421,
	"./media/events/oneyr-complete.jpg": 41153,
	"./media/events/organized-children's-day.jpg": 45107,
	"./media/events/orientation.png": 25505,
	"./media/events/prematurity-collage.jpg": 12851,
	"./media/events/prematurity-collage.png": 19031,
	"./media/events/ram.jpg": 57009,
	"./media/events/traning.png": 62856,
	"./media/events/tumakurupooja.jpg": 83511,
	"./media/events/women's-day-celebrationn.jpg": 18829,
	"./media/events/women-mysore.jpg": 76893,
	"./media/events/women-sday.jpg": 93689,
	"./media/events/womens-day-celebration-2018.jpg": 23498,
	"./media/events/yoga-day-june21-.jpg": 65244,
	"./media/newspaper-bg.jpg": 77984,
	"./media/newspaper-bg.webp": 62861,
	"./media/packageimage/child-2.jpg": 44799,
	"./media/packageimage/child-3.jpg": 85884,
	"./media/packageimage/obesity-package.jpg": 39281,
	"./media/packageimage/package-01.jpg": 97982,
	"./media/packageimage/package-02.jpg": 28824,
	"./media/packageimage/package-03-men-fertility-care.jpg": 28957,
	"./media/packageimage/package-04-women-fertility-care.jpg": 35948,
	"./media/packageimage/package-05.jpg": 64656,
	"./media/packageimage/package-10.jpg": 97458,
	"./media/packageimage/package-pcos.jpg": 4983,
	"./media/packageimage/package-women-health.jpg": 49425,
	"./media/packageimage/women-diabetic.jpg": 79638,
	"./media/packageimage/women-quickscreening.jpg": 12254,
	"./media/press-release-full.jpg": 78313,
	"./media/press-release-mob.jpg": 67921,
	"./media/press/asset12-50.jpg": 89885,
	"./media/press/asset13-50.jpg": 99105,
	"./media/press/asset14-50.jpg": 19131,
	"./media/press/asset15-50.jpg": 55062,
	"./media/press/asset16-50.jpg": 54407,
	"./media/press/asset17-50.jpg": 87119,
	"./media/press/asset18-50.jpg": 34823,
	"./media/press/pratinidhi.jpeg": 97214,
	"./media/press/premature-day.jpeg": 11989,
	"./media/press/prematuritydaymysore.jpg": 68404,
	"./media/press/prematuritydayramanagara.jpg": 44570,
	"./media/press/press-1.jpg": 88588,
	"./media/press/press-10.jpeg": 32165,
	"./media/press/press-11.jpeg": 81658,
	"./media/press/press-12.jpeg": 15081,
	"./media/press/press-2.jpg": 26901,
	"./media/press/press-3.jpg": 54359,
	"./media/press/press-4.jpg": 25457,
	"./media/press/press-5.jpg": 82689,
	"./media/press/press-6-old.jpeg": 61046,
	"./media/press/press-6.jpeg": 65055,
	"./media/press/press-7.jpeg": 70896,
	"./media/press/press-8.jpeg": 79338,
	"./media/press/press-8.png": 93851,
	"./media/press/press-9.jpeg": 48193,
	"./media/press/press-new-1.jpeg": 37767,
	"./media/press/press-new-2.jpeg": 83424,
	"./media/press/press-new-3.jpeg": 89342,
	"./nabh.png": 13678,
	"./nabh2.png": 63930,
	"./nabh3.png": 91522,
	"./nav.png": 32498,
	"./new-our-journey.jpeg": 74193,
	"./our-journey.jpg": 15826,
	"./our-packages/banner/Artboard 1 copy 2.jpg": 8834,
	"./our-packages/banner/Artboard 1 copy 3.jpg": 30814,
	"./our-packages/banner/Artboard 1 copy.jpg": 37208,
	"./our-packages/banner/Artboard 1.jpg": 91392,
	"./our-packages/details/luxury.jpg": 20682,
	"./our-packages/details/semi suite.jpg": 37802,
	"./our-packages/details/suite.jpg": 24541,
	"./our-packages/details/twin sharing.jpg": 95232,
	"./our-packages/icons/baby-book.png": 44659,
	"./our-packages/icons/baby-dress.png": 28413,
	"./our-packages/icons/baby-on-board.png": 12276,
	"./our-packages/icons/baby-photo-shoot.png": 9075,
	"./our-packages/icons/body-massage.png": 9386,
	"./our-packages/icons/candle-light-dinner.png": 19714,
	"./our-packages/icons/car-decoration.png": 2566,
	"./our-packages/icons/first-post-delivery.png": 20879,
	"./our-packages/icons/kangaroo-care-gift.png": 82802,
	"./our-packages/icons/luxury.png": 70547,
	"./our-packages/icons/semi-suite.png": 51208,
	"./our-packages/icons/twin-sharing.png": 90454,
	"./our-packages/icons/yoga-session.png": 97900,
	"./our-packages/luxury.jpg": 9924,
	"./our-packages/semi suite.jpg": 48915,
	"./our-packages/suite.jpg": 28979,
	"./our-packages/twin sharing.jpg": 27245,
	"./page-header.jpg": 31109,
	"./parallax-lab-image.jpg": 97289,
	"./parallax-lab-image.webp": 39050,
	"./portrait-of-mother-and-child-laughing-and-playing-PXEWE3Z.jpg": 80491,
	"./road-map-horizontal1.jpg": 84574,
	"./road-map-horizontal2.jpg": 90572,
	"./road-map-horizontal3.jpg": 30262,
	"./round.png": 70483,
	"./sec-2-bg-1.png": 25142,
	"./sec-2-bg-1.webp": 89035,
	"./separator1.png": 6401,
	"./separator10.svg": 92493,
	"./separator11.svg": 44493,
	"./separator12.svg": 84973,
	"./separator13.svg": 27417,
	"./separator14.svg": 76056,
	"./separator15.svg": 81725,
	"./separator16.svg": 66202,
	"./separator17.svg": 82115,
	"./separator18.svg": 97450,
	"./separator19.svg": 32164,
	"./separator2.png": 25146,
	"./separator20.svg": 34170,
	"./separator3.svg": 24478,
	"./separator4.png": 7176,
	"./separator4.svg": 68731,
	"./separator5.svg": 10509,
	"./separator6.svg": 1678,
	"./separator7.svg": 91008,
	"./separator8.svg": 13766,
	"./separator9.svg": 3722,
	"./service/child-care-hospital-new.png": 81001,
	"./service/child-development.png": 14554,
	"./service/child-developmental-clinc.png": 91916,
	"./service/childdevelopmetclinic.png": 17232,
	"./service/childdevelopmetclinic.png 2-webp.webp": 6051,
	"./service/childdevelopmetclinic.png 2.png": 50124,
	"./service/cosmetic gyanecology.jpg": 63260,
	"./service/cosmetic-gynecology.jpeg": 58026,
	"./service/dental.jpg": 29242,
	"./service/details/bangalore-fertility.jpg": 37231,
	"./service/details/banners/lactation-service.jpg": 99913,
	"./service/details/center_fertility_center.jpg": 20026,
	"./service/details/child-development-clinic-new1.jpg": 31790,
	"./service/details/child-development-new.jpg": 48297,
	"./service/details/childdevelopmetclinic.png": 25355,
	"./service/details/cosmetic-gynecology-new1.jpg": 7119,
	"./service/details/cosmetic-gynecology.jpg": 50147,
	"./service/details/dental.jpg": 17575,
	"./service/details/dentistry.jpg": 46247,
	"./service/details/dentistry1.jpg": 65010,
	"./service/details/fertility-center.jpg": 58335,
	"./service/details/fertility-new.jpeg": 20075,
	"./service/details/fertility-new.jpg": 90249,
	"./service/details/fertility-new1.jpg": 77510,
	"./service/details/fetal-medicine-new.jpg": 49820,
	"./service/details/fetal-medicine-new1.jpg": 2811,
	"./service/details/gynecology-1.jpg": 9667,
	"./service/details/gynecology-new.jpg": 66188,
	"./service/details/infant-care-new.jpg": 83394,
	"./service/details/infant-care-paediatrics-new1.jpg": 44081,
	"./service/details/kangaroo-care-clinics.jpg": 745,
	"./service/details/kangaroo-clinics.jpg": 96630,
	"./service/details/kangaroo-kids.jpg": 85539,
	"./service/details/kids-banner.png": 1407,
	"./service/details/lactation-preview.jpg": 86941,
	"./service/details/lactation-services-new1.jpg": 83638,
	"./service/details/lactition.jpg": 75588,
	"./service/details/maternity-new.jpg": 3897,
	"./service/details/maternity-new1.jpg": 36144,
	"./service/details/mysore-fetalmedicine.jpg": 73630,
	"./service/details/mysore-preview-fertility.jpg": 83754,
	"./service/details/neonatal-icu-new1.jpg": 30507,
	"./service/details/neonatal-new.jpg": 75967,
	"./service/details/new-images/CHILD-DEVELOPMENT-CLINIC.jpg": 82226,
	"./service/details/new-images/COSMETIC-GYNAECOLOGY.jpg": 88520,
	"./service/details/new-images/FERTILITY.jpg": 39474,
	"./service/details/new-images/GYNAECOLOGY.jpg": 51397,
	"./service/details/new-images/INFANT-CARE.jpg": 4732,
	"./service/details/new-images/LACTATION.jpg": 78885,
	"./service/details/new-images/LEVEL-3B-NICU.jpg": 23657,
	"./service/details/new-images/PAEDIATRIC-HDU.jpg": 17924,
	"./service/details/new-images/RADIOLOGY.jpg": 39570,
	"./service/details/new-images/maternity.jpg": 73081,
	"./service/details/paediatric-hdu1.jpg": 53296,
	"./service/details/paediatric-new.jpg": 60010,
	"./service/details/ramanagar-preview-fertility.jpg": 28179,
	"./service/details/ramnagar_feature.jpg": 92009,
	"./service/details/service-child-development-clinic.jpg": 71042,
	"./service/details/service-fertility.jpg": 76990,
	"./service/details/service-fetalmedicine.jpg": 69327,
	"./service/details/service-gynaecology-1.jpg": 14796,
	"./service/details/service-gynaecology.jpg": 25115,
	"./service/details/service-maternity.jpg": 36305,
	"./service/details/service-nicu-1.jpg": 60002,
	"./service/details/service-nicu.jpg": 14210,
	"./service/details/service-other-facilities.jpg": 88921,
	"./service/details/service-pediatrics-hdu.jpg": 92034,
	"./service/details/service-pediatrics.jpg": 85411,
	"./service/details/yoga-banner.jpg": 57436,
	"./service/details/yoga-img.jpg": 89785,
	"./service/fertility.jpg": 70027,
	"./service/fetalmedicine.jpg": 52481,
	"./service/gynocology-webp.webp": 35394,
	"./service/gynocology.png": 32413,
	"./service/infantandpediatriccare.jpg": 28650,
	"./service/kats-new.png": 31159,
	"./service/kats.jpg": 88870,
	"./service/lactation-home-services.jpg": 68013,
	"./service/lactationandhomeservices.jpg": 50914,
	"./service/maternity.jpg": 16190,
	"./service/maternity1.jpg": 37952,
	"./service/new-banner/CHILD-DEVELOPMENT-CLINIC.jpg": 66419,
	"./service/new-banner/COSMETIC-GYNAECOLOGY.jpg": 49391,
	"./service/new-banner/GYNAECOLOGY.jpg": 79303,
	"./service/new-banner/INFANT-CARE.jpg": 58683,
	"./service/new-banner/LACTATION.jpg": 65742,
	"./service/new-banner/LEVEL-3B-NICU.jpg": 15807,
	"./service/new-banner/OBSTETRICS.jpg": 72059,
	"./service/new-banner/PAEDIATRIC-HDU.jpg": 83412,
	"./service/new-banner/RADIOLOGY.jpg": 86083,
	"./service/new-banner/fertiloty.jpg": 8330,
	"./service/new-banner/yoga-banner.jpg": 88050,
	"./service/nicu.jpg": 6666,
	"./service/old/old_serv-1.jpg": 66851,
	"./service/old/old_serv-2.jpg": 49093,
	"./service/old/old_serv-3.jpg": 28579,
	"./service/old/old_serv-4.jpg": 86030,
	"./service/old/old_serv-6.jpg": 60617,
	"./service/old/serv-1-old.jpg": 67630,
	"./service/old/serv-2-old.jpg": 51137,
	"./service/old/serv-3-old.jpg": 22126,
	"./service/old/serv-4-old.jpg": 51637,
	"./service/old/serv-6-old.jpg": 1884,
	"./service/pediatrichdu.jpg": 93280,
	"./service/serv-1.jpg": 55439,
	"./service/serv-1.webp": 91451,
	"./service/serv-2.jpg": 49446,
	"./service/serv-2.webp": 89984,
	"./service/serv-3.jpg": 40255,
	"./service/serv-3.webp": 40435,
	"./service/serv-4.jpg": 59429,
	"./service/serv-4.webp": 63385,
	"./service/serv-5.jpg": 36826,
	"./service/serv-5.webp": 77884,
	"./service/serv-6.jpg": 5172,
	"./service/serv-6.webp": 47480,
	"./service/serv-new-1.jpg": 28562,
	"./service/serv-new-2.jpg": 97521,
	"./service/serv-new-3.jpg": 87711,
	"./service/serv-new-4.jpg": 43823,
	"./service/serv-new-5.jpg": 22636,
	"./service/serv-new-6.jpg": 59696,
	"./service/service-bg-1.jpg": 7749,
	"./service/service-bg-1.webp": 82014,
	"./service/service-icon-1.png": 1367,
	"./service/service-icon-2.png": 99388,
	"./service/service-icon-3.png": 40754,
	"./service/service-icon-4.png": 82921,
	"./service/service-icon-5.png": 85834,
	"./service/service-icon-6.png": 2506,
	"./service/yoga-banner.jpg": 29511,
	"./slider/2025/1_2025_banner-webp.webp": 62604,
	"./slider/2025/1_2025_banner.jpg": 35854,
	"./slider/2025/1_2025_bannerm-webp.webp": 11641,
	"./slider/2025/1_2025_bannerm.jpg": 19259,
	"./slider/2025/20000-mob.jpg": 96716,
	"./slider/2025/20000.jpg": 20173,
	"./slider/2025/2_2025_banner-webp.webp": 40807,
	"./slider/2025/2_2025_banner.jpg": 40744,
	"./slider/2025/2_2025_bannerm-webp.webp": 54945,
	"./slider/2025/2_2025_bannerm.jpg": 83556,
	"./slider/2025/3_2025_banner-webp.webp": 82144,
	"./slider/2025/3_2025_banner.jpg": 40484,
	"./slider/2025/3_2025_bannerm-webp.webp": 78329,
	"./slider/2025/3_2025_bannerm.jpg": 25658,
	"./slider/2025/4_2025_banner_new-webp.webp": 63180,
	"./slider/2025/4_2025_banner_new.jpg": 50299,
	"./slider/2025/4_2025_bannermm-webp.webp": 56262,
	"./slider/2025/4_2025_bannermm.jpg": 14519,
	"./slider/2025/5_2025_banner-webp.webp": 6490,
	"./slider/2025/5_2025_banner.jpg": 23285,
	"./slider/2025/5_2025_bannerm-webp.webp": 77728,
	"./slider/2025/5_2025_bannerm.jpg": 8552,
	"./slider/2025/6_2025_banner-webp.webp": 3117,
	"./slider/2025/6_2025_banner.jpg": 54735,
	"./slider/2025/6_2025_bannerm-webp.webp": 92476,
	"./slider/2025/6_2025_bannerm.jpg": 43232,
	"./slider/2025/7_2025_banner-webp.webp": 29528,
	"./slider/2025/7_2025_banner.jpg": 11327,
	"./slider/2025/7_2025_bannerm-webp.webp": 83982,
	"./slider/2025/7_2025_bannerm.jpg": 88803,
	"./slider/2025/8_2025_banner.jpg": 95535,
	"./slider/2025/8_2025_bannerm.jpg": 95344,
	"./slider/2025/bannar-desktop.jpg": 55930,
	"./slider/2025/banner-13.jpeg": 86060,
	"./slider/2025/banner-big.jpg": 36957,
	"./slider/2025/banner-mob.jpg": 58092,
	"./slider/2025/bannermobile-13.jpeg": 16466,
	"./slider/2025/coming-soon-banner-web-webp.webp": 69429,
	"./slider/2025/coming-soon-banner-web.jpg": 32708,
	"./slider/2025/coming-soon-mobi-webp.webp": 27701,
	"./slider/2025/coming-soon-mobi.jpg": 5294,
	"./slider/2025/home-banner.jpg": 27219,
	"./slider/2025/kat-new-banner-mob-webp.webp": 9194,
	"./slider/2025/kat-new-banner-mob.jpg": 59168,
	"./slider/2025/kat-new-banner-webp.webp": 66153,
	"./slider/2025/kat-new-banner.jpg": 50185,
	"./slider/2025/kc-banner-home-1.jpg": 52333,
	"./slider/2025/kc-banner-home-1mob.jpg": 36701,
	"./slider/2025/kc-uagthi-mobile.jpeg": 17126,
	"./slider/2025/kc-ugadhi.jpeg": 97454,
	"./slider/2025/new-banner-10-mobile.jpeg": 44680,
	"./slider/2025/new-banner-10.jpeg": 49638,
	"./slider/2025/new-banner-2026-mobile-1.jpeg": 35546,
	"./slider/2025/new-banner-2026-mobile.jpeg": 56493,
	"./slider/2025/new-banner-2026-new.jpeg": 54802,
	"./slider/2025/new-banner-2026.jpeg": 39741,
	"./slider/2025/new-banner-9-mobile.jpeg": 45952,
	"./slider/2025/new-banner-9.jpeg": 9688,
	"./slider/2025/new-banner-desktop-kats.jpg": 19694,
	"./slider/2025/new-banner-mobile-kats.jpg": 39618,
	"./slider/2025/new-banner-mobile.png": 40556,
	"./slider/2025/new-banner.jpg": 20373,
	"./slider/2025/tumkuru-desk-banner.jpeg": 962,
	"./slider/2025/tumkuru-mob-banner.jpg": 80201,
	"./slider/2025/website-banner-small.jpg": 38824,
	"./slider/Kids-webbanner.jpg": 53242,
	"./slider/banner-12.jpg": 19132,
	"./slider/banner-12.webp": 68377,
	"./slider/banner-13.jpg": 98641,
	"./slider/banner-13.webp": 58097,
	"./slider/banner1.jpg": 17018,
	"./slider/banner111.webp": 22913,
	"./slider/banner2.jpg": 55603,
	"./slider/banner2.webp": 23624,
	"./slider/bg-01.jpg": 13799,
	"./slider/bg-01.webp": 14068,
	"./slider/bg-02.jpg": 29389,
	"./slider/bg-02.webp": 52247,
	"./slider/bg-03.jpg": 32313,
	"./slider/bg-03.webp": 44783,
	"./slider/bg-04.jpg": 87545,
	"./slider/bg-04.webp": 85762,
	"./slider/bg-05.jpg": 96366,
	"./slider/bg-05.webp": 53890,
	"./slider/bg-06-old.jpg": 79775,
	"./slider/bg-06.jpg": 37275,
	"./slider/bg-06.webp": 41030,
	"./slider/bg-07.jpg": 22377,
	"./slider/bg-08c.jpg": 96889,
	"./slider/bg-09.jpg": 45029,
	"./slider/bg-09_old.jpg": 40745,
	"./slider/bg-10.jpeg": 47870,
	"./slider/bg-10.jpg": 17189,
	"./slider/desktop_1.jpg": 15503,
	"./slider/desktop_2.jpg": 11256,
	"./slider/desktop_3.jpg": 24482,
	"./slider/desktop_4.jpg": 31561,
	"./slider/fertility logo.png": 64972,
	"./slider/kids-webbanner.webp": 64971,
	"./slider/new_slider/14_1_desktop.jpg": 6755,
	"./slider/new_slider/14_1_desktop_1.jpg": 51135,
	"./slider/new_slider/14_1_mobile.jpg": 27737,
	"./slider/new_slider/14_2_desktop.jpg": 58669,
	"./slider/new_slider/14_2_mobile.jpg": 25882,
	"./slider/new_slider/14_3_desktop.jpg": 77596,
	"./slider/new_slider/14_3_mobile.jpg": 28912,
	"./slider/new_slider/14_4_desktop.jpg": 61878,
	"./slider/new_slider/14_4_desktop_1.jpg": 4744,
	"./slider/new_slider/14_4_mobile.jpg": 51185,
	"./slider/new_slider/14_5_desktop.jpg": 35996,
	"./slider/new_slider/14_5_mobile.jpg": 10818,
	"./slider/new_slider/14_6_desktop.jpg": 26854,
	"./slider/new_slider/14_6_mobile.jpg": 47460,
	"./slider/new_slider/14_7_desktop.jpg": 26295,
	"./slider/new_slider/14_7_mobile.jpg": 62387,
	"./slider/new_slider/14_8_desktop.jpg": 66076,
	"./slider/new_slider/14_8_mobile.jpg": 57615,
	"./slider/new_slider/3_11_2023_desktop.jpg": 97129,
	"./slider/new_slider/3_11_2023_desktop_clinic.jpg": 83846,
	"./slider/new_slider/3_11_2023_desktop_dentistry.jpg": 97120,
	"./slider/new_slider/3_11_2023_desktop_fertility.jpg": 35856,
	"./slider/new_slider/3_11_2023_desktop_kats.jpg": 16125,
	"./slider/new_slider/3_11_2023_desktop_nicu.jpg": 31252,
	"./slider/new_slider/3_11_2023_mobile.jpg": 95458,
	"./slider/new_slider/3_11_2023_mobile_clinic.jpg": 75993,
	"./slider/new_slider/3_11_2023_mobile_dentistry.jpg": 41867,
	"./slider/new_slider/3_11_2023_mobile_fertility.jpg": 15495,
	"./slider/new_slider/3_11_2023_mobile_kats.jpg": 93940,
	"./slider/new_slider/3_11_2023_mobile_nicu.jpg": 16582,
	"./slider/new_slider/banner-11.jpg": 90581,
	"./slider/new_slider/banner-22.jpg": 54339,
	"./slider/new_slider/banner-77.jpg": 99731,
	"./slider/new_slider/banner-80-mobile.jpg": 28030,
	"./slider/new_slider/banner-80.jpg": 35818,
	"./slider/new_slider/banner_1.jpg": 65131,
	"./slider/new_slider/banner_10_desktop.jpg": 50385,
	"./slider/new_slider/banner_10_mobile.jpg": 4244,
	"./slider/new_slider/banner_2.jpg": 5938,
	"./slider/new_slider/banner_3.jpg": 36931,
	"./slider/new_slider/banner_4.jpg": 85525,
	"./slider/new_slider/banner_9_desktop.jpg": 41838,
	"./slider/new_slider/banner_9_mobile.jpg": 70172,
	"./slider/new_slider/banner__1.jpg": 96597,
	"./slider/new_slider/banner__2.jpg": 85901,
	"./slider/new_slider/banner__3.jpg": 15041,
	"./slider/new_slider/banner__4.jpg": 16665,
	"./slider/new_slider/banner_collage.jpg": 49884,
	"./slider/new_slider/banner_collage_mobile.jpg": 81981,
	"./slider/new_slider/bengaluru-mobile.jpg": 76501,
	"./slider/new_slider/bengaluru.jpg": 93455,
	"./slider/new_slider/desk1306.jpg": 76462,
	"./slider/new_slider/desk13062.jpg": 82334,
	"./slider/new_slider/fertility-mobile.jpg": 53539,
	"./slider/new_slider/fertility.jpg": 5038,
	"./slider/new_slider/kats-1520-350.jpg": 4690,
	"./slider/new_slider/kats-500-500.jpg": 13420,
	"./slider/new_slider/kc-banner-88.jpg": 65730,
	"./slider/new_slider/mob1306.jpg": 52170,
	"./slider/new_slider/mob13062.jpg": 63025,
	"./slider/new_slider/mobile_1.jpg": 9009,
	"./slider/new_slider/mobile_2.jpg": 77282,
	"./slider/new_slider/mobile_3.jpg": 86850,
	"./slider/new_slider/mobile_4.jpg": 99870,
	"./slider/new_slider/mysore.jpg": 24448,
	"./slider/new_slider/website-banner-fertility.jpg": 78021,
	"./slider/new_slider/website-banner-fertility1.jpg": 87251,
	"./slider/new_slider/website-banner-fertility2.jpg": 12015,
	"./slider/new_slider/website-banner-fertilityph.jpg": 6375,
	"./slider/slider-10.jpg": 10549,
	"./slider/slider-11.jpg": 22951,
	"./slider/women_s_day_banner-01.jpg": 79367,
	"./spurtii.jpeg": 15381,
	"./stage1.png": 21151,
	"./stage1.webp": 17558,
	"./stage2.png": 86049,
	"./stage2.webp": 69338,
	"./stage3.png": 20272,
	"./stage3.webp": 19279,
	"./team/01.jpg": 57569,
	"./team/02.jpg": 84722,
	"./team/03.jpg": 52390,
	"./team/04.jpg": 31901,
	"./team/05.jpg": 65724,
	"./team/06.jpg": 59856,
	"./team/details/date-1.png": 54486,
	"./team/details/date-2.png": 68892,
	"./team/details/date-3.png": 99587,
	"./team/h-2-01.png": 83878,
	"./team/h-2-02.png": 92076,
	"./team/h-2-03.png": 87650,
	"./team/h-2-04.png": 14843,
	"./team/team-arrow.png": 68477,
	"./team/team-bg-2.jpg": 3119,
	"./team/team-bg.jpg": 73843,
	"./team/team-details.jpg": 79171,
	"./testimonial/bg-dot.png": 34299,
	"./testimonial/client-01.jpg": 21726,
	"./testimonial/client-02.jpg": 16337,
	"./testimonial/client-03.jpg": 70538,
	"./testimonial/h-2-t-01.png": 81689,
	"./testimonial/h-2-t-02.png": 18635,
	"./testimonial/h-2-t-03.png": 1751,
	"./title6.png": 83629,
	"./tumkur.jpg": 17550,
	"./uc.jpg": 29080,
	"./uc.webp": 77545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25459;